import type * as React from "react";
import { type FC } from "react";
import { Navigate, useLocation } from "react-router";

interface Props {
    component: React.ComponentType<any>;
    isAuthenticated: boolean;
    isLoading: boolean;
}

const PrivateRoute: FC<Props> = ({
    component: Component,
    isAuthenticated,
    isLoading,
    ...rest
}) => {
    const location = useLocation();

    if(isLoading) {
        return <div className="loading-user" />;
    }

    if(!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                state={{
                    from: location,
                }}
            />
        );
    }

    return (
        <Component {...rest} />
    );
};

export default PrivateRoute;
